<template>
  <form @submit.prevent="handleSubmit">
    <b-field label="Email">
      <b-input name="email" v-model="email" type="email" autoComplete="email" required></b-input>
    </b-field>
    <b-field label="Password">
      <b-input name="password" v-model="password" type="password" required></b-input>
    </b-field>
    <b-field>
      <p class="control">
        <button :class="buttonClasses" type="submit">
          {{ buttonText }}
        </button>
      </p>
    </b-field>
  </form>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'SignIn',
  props: ['buttonText', 'onSubmit', 'isSignUp'],
  data() {
    return {
      email: '',
      password: '',
    }
  },
  computed: {
    ...mapGetters([
      'userIsLoading'
    ]),
    buttonClasses() {
      return {
        button: true,
        'is-loading': this.userIsLoading,
        'is-primary': true,
        'is-medium': true
      }
    }
  },
  methods: {
    ...mapActions([
      'userEmailSignIn'
    ]),
    handleSubmit() {
      this.onSubmit({ email: this.email, password: this.password })
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  align-items: center;
  display: flex;
  flex-direction: column;
}

.card {
  border-radius: 4px;
  max-width: 500px;
  width: 100%;
}

.logo {
  font-size: 3rem;
}

button {
  width: 100%;
}
</style>
